import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for products third by bet shop.
 * @extends JetView
 */
export default class tableProductsThirdByBetShopView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Get current user parameter
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            height: screen.width < 500 ? 400 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Editar', // Tooltip for the column
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('betShopReportsProductsThirdEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Return edit icon if permission granted
                                        } else {
                                            return ''; // Return empty if no permission
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'ID', // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ProductsThird', // Column ID
                                    header: _('Producto Terceros'), // Localized column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') }, // Active option
                                        { id: 'I', value: _('Inactivado') }, // Inactive option
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Click event for edit action
                                    $$('EditProductsThirdByBetShop').show(); // Show edit popup
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch setting
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var filter = ''; // Filter string
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'BetShop/GetProductsThird?FromId=' + cur_user + '&'; // API URL for fetching products
        var datePopup = []; // Array for date options
        var popupAdd = ''; // Variable for add popup

        // AJAX request to fetch products for the combo
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Accounting/GetProductsThirdSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    // Error handler
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handler
                    var resp = JSON.parse(text); // Parse response
                    datePopup = resp.Data; // Set date options from response
                    popupAdd = webix.ui({
                        // Create add popup
                        view: 'window',
                        id: 'AddProductsThird', // ID for the add popup
                        head: {
                            view: 'toolbar',
                            cols: [
                                { view: 'label', label: _('Añadir') }, // Label for add
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide popup on close
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center position
                        modal: true, // Modal popup
                        body: {
                            view: 'form', // Form view
                            id: 'addform', // ID for the form
                            elements: [
                                {
                                    view: 'combo', // Combo for products
                                    label: _('Producto Tercero'), // Localized label
                                    name: 'ProductsThird', // Name for the form field
                                    options: datePopup, // Options for the combo
                                },
                                {
                                    view: 'combo', // Combo for status
                                    label: _('Estado'), // Localized label
                                    name: 'IsActivate', // Name for the form field
                                    options: [
                                        { id: 'A', value: _('Activado') }, // Active option
                                        { id: 'I', value: _('Inactivado') }, // Inactive option
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            view: 'button', // Cancel button
                                            value: _('Cancelar'), // Localized label
                                            click: function () {
                                                this.getTopParentView().hide(); // Hide popup on cancel
                                                $$('addform').setValues(
                                                    $$('addform').getCleanValues(), // Reset form values
                                                );
                                            },
                                        },
                                        {
                                            view: 'button', // Save button
                                            type: 'form',
                                            value: _('Guardar'), // Localized label
                                            click: function ($e) {
                                                var values = $$('addform').getValues(); // Get form values
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'BetShop/ProductsThird',
                                                        '{"ProductsThird":"' +
                                                            values.ProductsThird +
                                                            '", "BetShop":"' +
                                                            cur_user +
                                                            '", "IsActivate":"' +
                                                            values.IsActivate +
                                                            '"}', // Send product data
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                // Error handler
                                                                webix.message(_('Error! ')); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                // Success handler
                                                                webix.message(_('Agregado')); // Show success message
                                                                grid.clearAll(); // Clear grid data
                                                                grid.load(
                                                                    url +
                                                                        '?start=0&count=' +
                                                                        grid.data.$pagesize +
                                                                        filter, // Reload grid data
                                                                );
                                                            },
                                                        },
                                                    );
                                                $$('addform').setValues(
                                                    $$('addform').getCleanValues(), // Reset form values
                                                );
                                                this.getTopParentView().hide(); // Hide popup
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    });
                },
            });

        // Create edit popup
        var popup = webix.ui({
            view: 'window',
            id: 'EditProductsThirdByBetShop', // ID for the edit popup
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar') }, // Label for edit
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center position
            modal: true, // Modal popup
            body: {
                view: 'form', // Form view
                id: 'editForm', // ID for the form
                elements: [
                    { view: 'text', label: 'ID', name: 'Id', readonly: true }, // Readonly ID field
                    {
                        view: 'combo', // Combo for products
                        label: _('Producto Tercero'), // Localized label
                        name: 'ProductsThird', // Name for the form field
                        readonly: true, // Readonly field
                    },
                    {
                        view: 'combo', // Combo for status
                        label: _('Estado'), // Localized label
                        name: 'IsActivate', // Name for the form field
                        options: [
                            { id: 'A', value: _('Activado') }, // Active option
                            { id: 'I', value: _('Inactivado') }, // Inactive option
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'), // Localized label
                                click: function () {
                                    this.getTopParentView().hide(); // Hide popup on cancel
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form',
                                value: _('Guardar'), // Localized label
                                click: function ($e) {
                                    var values = $$('editForm').getValues(); // Get form values
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'BetShop/ProductsThird',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "ProductsThird":"' +
                                                values.ProductsThird +
                                                '", "BetShop":"' +
                                                cur_user +
                                                '", "IsActivate":"' +
                                                values.IsActivate +
                                                '"}', // Send product data
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error handler
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success handler
                                                    webix.message(
                                                        _('Actualizado'), // Show success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Hide popup
                                },
                            },
                        ],
                    },
                ],
            },
        });
        $$('editForm').bind($$('datatable')); // Bind edit form to datatable

        // Event listener for filtering products
        this.on(this.app, 'productsThird:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to filter
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to filter
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date from start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date from end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Reload grid data with filters
            filter = string1; // Update filter
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Reload grid data with sorting
            );
        });

        // Event listener for adding products
        this.on(this.app, 'addProductsThird:button', (filter) => {
            popupAdd.show(); // Show add popup
        });
    }
}

// FILE DOCUMENTED
